import type { AccentEntry, CashflowAccent, AccentPalette } from "./types";
import { ACCENT_FINANCIAL_ENTERPRISE, ACCENT_EXECUTIVE_REPORTING, ACCENT_TABLEAU, ACCENT_IBM_CARBON, ACCENT_STRIPE, ACCENT_NOTION, ACCENT_MUTED_DUSTY, ACCENT_SOFT_PASTEL } from "./palettes";

export type { AccentEntry, AccentIconColors, CashflowAccent, AccentPalette } from "./types";
export * from "./palettes";

const FALLBACK_ICON = "ri-question-line";

export const PIE_DEFAULT_FILL = "#8884d8";

export enum AccentName {
    FinancialEnterprise = "FINANCIAL_ENTERPRISE",
    ExecutiveReporting = "EXECUTIVE_REPORTING",
    Tableau = "TABLEAU",
    IbmCarbon = "IBM_CARBON",
    Stripe = "STRIPE",
    Notion = "NOTION",
    MutedDusty = "MUTED_DUSTY",
    SoftPastel = "SOFT_PASTEL",
}

const ACCENT_BY_NAME: Record<AccentName, AccentPalette> = {
    [AccentName.FinancialEnterprise]: ACCENT_FINANCIAL_ENTERPRISE,
    [AccentName.ExecutiveReporting]: ACCENT_EXECUTIVE_REPORTING,
    [AccentName.Tableau]: ACCENT_TABLEAU,
    [AccentName.IbmCarbon]: ACCENT_IBM_CARBON,
    [AccentName.Stripe]: ACCENT_STRIPE,
    [AccentName.Notion]: ACCENT_NOTION,
    [AccentName.MutedDusty]: ACCENT_MUTED_DUSTY,
    [AccentName.SoftPastel]: ACCENT_SOFT_PASTEL,
};

export const ACTIVE_ACCENT_NAME = AccentName.SoftPastel;

const ACTIVE_ACCENT = ACCENT_BY_NAME[ACTIVE_ACCENT_NAME];

function entryForIcon(icon: string | null | undefined): AccentEntry {
    const key = icon && icon in ACTIVE_ACCENT.icons ? icon : FALLBACK_ICON;
    return ACTIVE_ACCENT.icons[key];
}

export function getAccentPillColor(icon: string | null | undefined): string {
    return entryForIcon(icon).pillHex;
}

export function getAccentChartColor(icon: string | null | undefined): string {
    return entryForIcon(icon).chartHex;
}

export function getActiveAccentColors(): string[] {
    return Object.values(ACTIVE_ACCENT.icons).map((entry) => entry.chartHex);
}

export function getCashflowAccentColors(): { inflow: CashflowAccent; outflow: CashflowAccent } {
    return { inflow: ACTIVE_ACCENT.inflow, outflow: ACTIVE_ACCENT.outflow };
}
